Vue.component('faqContent', {
  data() {
    return {
      searchTerm: '',
      autocompleteSuggestions: [],
      autocompleteOpen: false,
      searchAutocompleteIndex: -1,
      //timer: null,
      queryRunning: false,
      faqItems: []
    };
  },
    mounted() {
        var self = this;

        self.faqItems = jsonQuestions;
        
        document.addEventListener('click', function () {
            self.autocompleteOpen = false;
            self.searchAutocompleteIndex = -1;
            self.autocompleteSuggestions = [];
            self.searchTerm = '';
        });

  },
  methods: {

    onSearchArrowDown() {
          if (this.searchAutocompleteIndex < this.autocompleteSuggestions.length - 1) {
            this.searchAutocompleteIndex += 1;
          }
    },
    onSearchArrowUp() {
        if (this.searchAutocompleteIndex > 0) {
            this.searchAutocompleteIndex -= 1;
        }
    },
    onSearchEnter() {
        if (this.searchAutocompleteIndex >= 0) {
            this.openAutosuggestLink(this.autocompleteSuggestions[this.searchAutocompleteIndex].url);
        }
    },
    toggleAutocomplete (e) {
        if (e.target.value.length >= 3) {
            this.autocompleteOpen = !this.autocompleteOpen;
        }
    },
    openAutosuggestLink(url) {
        window.location.href = url;

      },

      filterResults() {
          this.autocompleteSuggestions = [];
          this.faqItems.forEach((item) => {
              if (item.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
                  /*|| item.answer.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1*/) {
                  this.autocompleteSuggestions.push(item);
              }
          });
      },

      fetchAutoComplete(e) {
          var self = this;

          self.autocompleteOpen = true;
          self.searchAutocompleteIndex = -1;

          self.filterResults();

          /*
          self.queryRunning = true;
          fetch('/api/search/faqautocomplete', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': document.documentElement.lang,
                  'X-Requested-With': 'XMLHttpRequest'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                  query: `${self.searchTerm}`,
              }),
          }).then(response => response.json()).then((autocompleteResponse) => {
              self.autocompleteSuggestions = autocompleteResponse;
              self.queryRunning = false;
          });
          */
      },
      autocomplete(e) {

        if (e.target.value.length >= 3) {

            this.fetchAutoComplete(e);
            /*

            if (!this.queryRunning) {
                clearTimeout(this.timer);

                this.timer = setTimeout(() => {

                    this.fetchAutoComplete(e);
                }
                    , 500);
            }
            else {

                clearTimeout(this.timer);

                this.timer = setTimeout(() => {

                        this.fetchAutoComplete(e);
                    }
                    , 700);
            }*/
        } else {

            //clearTimeout(this.timer);

            this.autocompleteOpen = false;
            this.searchAutocompleteIndex = -1;
            this.autocompleteSuggestions = [];
        }
    },
  },
});
